const LOCAL_ORIGIN = "https://mira.local";

export function safeReturnPath(value: string | null) {
  if (
    !value?.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    /%(?:2f|5c)/iu.test(value)
  ) {
    return "/";
  }

  try {
    const parsed = new URL(value, LOCAL_ORIGIN);
    if (parsed.origin !== LOCAL_ORIGIN) return "/";
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return "/";
  }
}

export function exactSafeReturnPath(value: string | null) {
  if (!value) return undefined;
  const safe = safeReturnPath(value);
  return safe === value ? safe : undefined;
}
